var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":_vm.size + 'px',"viewBox":"0 0 24 24","width":_vm.size + 'px',"fill":"currentColor"}},[_c('path',{attrs:{"d":"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }